/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&display=swap);@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400&display=swap);@import url(https://fonts.googleapis.com/css?family=Roboto+Mono:700&display=swap);.logout-component,app-logout~footer,app-logout~header{max-width:600px}app-logout .hiddenFrameHolder{font-size:0;display:inline}app-logout .hiddenFrameHolder iframe{border:0 transparent;width:1px;height:1px;margin:0 -1px -1px 0;padding:0}app-logout .loader-wrapper{height:46.08px}"];
export { styles as styles };
